import { atom } from 'recoil';
import { Dashboard, Workspace } from '../types/files';

const workspaceState = atom<Workspace | null>({
  key: 'workspace/workspace',
  default: null,
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['workspace/workspace', newValue]);
    });
  }],
});

const workspaceDashboardsState = atom<Dashboard[]>({
  key: 'workspaces/workspaceDashboards',
  default: [],
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['workspaces/workspaceDashboards', newValue]);
    });
  }],
});

export { workspaceState, workspaceDashboardsState };
